<!-- Mobile: Foxera Drawer Full -->
@if (responsiveService.isMobileView()) {
  <foxera-drawer-full
    [(visible)]="visible"
    [title]="''"
    [showFooter]="true"
    [useCustomFooter]="true"
    [useCustomHeader]="true"
    (onClose)="onClose()">
    
    <!-- Custom Header -->
    <div customHeader class="px-5 pt-4 pb-3">
      <div class="flex items-center justify-between">
        <h2 class="text-2xl font-bold text-grey-950">Filters</h2>
        <div class="flex items-center gap-2">
          <button
            type="button"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white/40 border border-white text-grey-950 hover:bg-primary-50 hover:border-primary-500 rounded-lg text-xs font-semibold transition-all duration-150 cursor-pointer"
            (click)="onClearAll()">
            <span class="pi pi-filter-slash text-[0.7rem]"></span>
            <span>Clear all</span>
          </button>
          <button
            (click)="onClose()"
            class="flex items-center justify-center w-9 h-9 rounded-full bg-white/60 hover:bg-white border border-white transition-all duration-150 [-webkit-tap-highlight-color:transparent]">
            <span class="pi pi-times text-grey-600 text-base"></span>
          </button>
        </div>
      </div>
    </div>
    
    <!-- Content -->
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>
    
    <!-- Custom Footer -->
    <div footer>
      <button
        type="button"
        class="w-full px-4 py-2.5 bg-primary-900 hover:bg-primary-950 text-white rounded-xl font-semibold transition-colors cursor-pointer text-sm"
        (click)="onApply()">
        Apply{{ activeFilterCount() > 0 ? ' (' + activeFilterCount() + ')' : '' }}
      </button>
    </div>
  </foxera-drawer-full>
}

<!-- Desktop: Original Dialog -->
@if (!responsiveService.isMobileView()) {
  <p-dialog
    [visible]="true"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    styleClass="exercise-filter-dialog"
    [style]="{ width: '28rem', maxHeight: '90vh' }">
    
    <!-- Header -->
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full">
        <h2 class="text-xl font-bold text-grey-900">Filters</h2>
        <button
          type="button"
          class="text-sm select-none text-primary-600 hover:text-primary-800 font-medium cursor-pointer"
          (click)="onClearAll()">
          Clear all
        </button>
      </div>
    </ng-template>

    <!-- Content -->
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>

    <!-- Footer -->
    <ng-template pTemplate="footer">
      <div class="flex items-center justify-between gap-3">
        <p-button
          label="Close"
          severity="secondary"
          [outlined]="true"
          (click)="onClose()">
        </p-button>
        <p-button
          [label]="'Apply' + (activeFilterCount() > 0 ? ' (' + activeFilterCount() + ')' : '')"
          severity="contrast"
          (click)="onApply()">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
}

<!-- Shared Filter Content Template -->
<ng-template #filterContent>
  <div class="space-y-3 select-none px-3 md:px-0">

    <!-- Movement Pattern -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasMovementPatternFilters() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('movementPattern')">
        <span [class]="hasMovementPatternFilters() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Movement Pattern
        </span>
        <i [class]="(hasMovementPatternFilters() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('movementPattern') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('movementPattern') && getMovementPatterns().length > 0) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '300px'">
          <div [class]="responsiveService.isMobileView() ? 'p-3 md:p-4 space-y-2' : 'p-3 md:p-4 space-y-2 max-h-64 overflow-y-auto'">
          @for (pattern of getMovementPatterns(); track pattern) {
            <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
              <p-checkbox
                [binary]="true"
                [ngModel]="isMovementPatternSelected(pattern)"
                (ngModelChange)="toggleMovementPattern(pattern)"
                [inputId]="'pattern-' + pattern">
              </p-checkbox>
              <span class="text-sm text-grey-800">{{ pattern }}</span>
            </label>
          }
          </div>
        </div>
      }
    </div>
    
    <!-- Type (Phase Type) - Hidden when hideTypeFilter is true -->
    @if (!hideTypeFilter) {
      <div class="border border-grey-100 rounded-xl overflow-hidden">
        <button
          type="button"
          [class]="hasPhaseFilter() 
            ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
            : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
          (click)="toggleSection('phase')">
          <span [class]="hasPhaseFilter() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
            Type
          </span>
          <i [class]="(hasPhaseFilter() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('phase') ? ' rotated' : '')"></i>
        </button>
        
        @if (isSectionExpanded('phase')) {
          <div class="expanded">
            <div class="p-3 md:p-4 space-y-2">
              <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="selectedPhases().warmup"
                  (ngModelChange)="togglePhase('warmup')"
                  inputId="phase-warmup">
                </p-checkbox>
                <span class="text-sm text-grey-800">Warm Up</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="selectedPhases().resistance"
                  (ngModelChange)="togglePhase('resistance')"
                  inputId="phase-resistance">
                </p-checkbox>
                <span class="text-sm text-grey-800">Resistance Training</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="selectedPhases().cardio"
                  (ngModelChange)="togglePhase('cardio')"
                  inputId="phase-cardio">
                </p-checkbox>
                <span class="text-sm text-grey-800">Cardio</span>
              </label>

              <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="selectedPhases().cooldown"
                  (ngModelChange)="togglePhase('cooldown')"
                  inputId="phase-cooldown">
                </p-checkbox>
                <span class="text-sm text-grey-800">Cool Down</span>
              </label>
            </div>
          </div>
        }
      </div>
    }

    <!-- Targeted Muscle -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasMuscleFilters() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('targetedMuscle')">
        <span [class]="hasMuscleFilters() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Targeted Muscle
        </span>
        <i [class]="(hasMuscleFilters() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('targetedMuscle') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('targetedMuscle') && filterConstants) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '500px'">
          <div class="p-3 md:p-4 space-y-3">
          
          <!-- Muscle Filter Mode -->
          <div class="pb-3 border-b border-grey-200">
            <p class="text-xs font-semibold text-grey-600 mb-2">Filter Mode</p>
            <div class="flex gap-2 md:gap-3">
              <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 px-2 py-1.5 rounded transition-colors">
                <p-radioButton
                  name="muscleFilterMode"
                  value="AtLeast"
                  [(ngModel)]="muscleFilterMode"
                  inputId="mode-atleast">
                </p-radioButton>
                <span class="text-sm text-grey-800">At Least</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 px-2 py-1.5 rounded transition-colors">
                <p-radioButton
                  name="muscleFilterMode"
                  value="Only"
                  [(ngModel)]="muscleFilterMode"
                  inputId="mode-only">
                </p-radioButton>
                <span class="text-sm text-grey-800">Only</span>
              </label>
            </div>
          </div>

          <!-- Muscle Selection -->
          <div [class]="responsiveService.isMobileView() ? 'space-y-3' : 'max-h-64 overflow-y-auto space-y-3'">
            @for (group of getMuscleGroups(); track group.groupName) {
              <div>
                <h4 class="text-xs font-bold text-grey-700 mb-2">{{ group.groupName }}</h4>
                <div class="space-y-2">
                  @for (muscle of group.muscles; track muscle) {
                    <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
                      <p-checkbox
                        [binary]="true"
                        [ngModel]="isMuscleSelected(muscle)"
                        (ngModelChange)="toggleMuscle(muscle)"
                        [inputId]="'muscle-' + muscle">
                      </p-checkbox>
                      <span class="text-sm text-grey-800">{{ muscle }}</span>
                    </label>
                  }
                </div>
              </div>
            }
          </div>
          </div>
        </div>
      }
    </div>

    <!-- Category -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasCategoryFilters() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('category')">
        <span [class]="hasCategoryFilters() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Category
        </span>
        <i [class]="(hasCategoryFilters() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('category') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('category') && filterConstants) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '400px'">
          <div class="p-3 md:p-4 space-y-2">
          @for (category of filterConstants.Category; track category) {
            <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
              <p-checkbox
                [binary]="true"
                [ngModel]="isCategorySelected(category)"
                (ngModelChange)="toggleCategory(category)"
                [inputId]="'category-' + category">
              </p-checkbox>
              <span class="text-sm text-grey-800">{{ category }}</span>
            </label>
          }
          </div>
        </div>
      }
    </div>

    <!-- Level -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasLevelFilters() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('level')">
        <span [class]="hasLevelFilters() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Level
        </span>
        <i [class]="(hasLevelFilters() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('level') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('level') && filterConstants) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '300px'">
          <div class="p-3 md:p-4 space-y-2">
          @for (level of filterConstants.Level; track level) {
            <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
              <p-checkbox
                [binary]="true"
                [ngModel]="isLevelSelected(level)"
                (ngModelChange)="toggleLevel(level)"
                [inputId]="'level-' + level">
              </p-checkbox>
              <span class="text-sm text-grey-800">{{ level }}</span>
            </label>
          }
          </div>
        </div>
      }
    </div>


    <!-- Main Equipment -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasMainEquipmentFilter() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('mainEquipment')">
        <span [class]="hasMainEquipmentFilter() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Main Equipment
        </span>
        <i [class]="(hasMainEquipmentFilter() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('mainEquipment') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('mainEquipment') && filterConstants) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '300px'">
          <div [class]="responsiveService.isMobileView() ? 'p-3 md:p-4 space-y-2' : 'p-3 md:p-4 space-y-2 max-h-64 overflow-y-auto'">
          @for (equipment of filterConstants.Equipment['Main Equipment']; track equipment) {
            <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
              <p-checkbox
                [binary]="true"
                [ngModel]="selectedMainEquipment() === equipment"
                (ngModelChange)="toggleMainEquipment(equipment)"
                [inputId]="'main-' + equipment">
              </p-checkbox>
              <span class="text-sm text-grey-800">{{ equipment }}</span>
            </label>
          }
          </div>
        </div>
      }
    </div>

    <!-- Support Equipment -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasSupportEquipmentFilter() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('supportEquipment')">
        <span [class]="hasSupportEquipmentFilter() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Support Equipment
        </span>
        <i [class]="(hasSupportEquipmentFilter() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('supportEquipment') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('supportEquipment') && filterConstants) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '300px'">
          <div [class]="responsiveService.isMobileView() ? 'p-3 md:p-4 space-y-2' : 'p-3 md:p-4 space-y-2 max-h-64 overflow-y-auto'">
          @for (equipment of filterConstants.Equipment['Support Equipment']; track equipment) {
            <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
              <p-checkbox
                [binary]="true"
                [ngModel]="selectedSupportEquipment() === equipment"
                (ngModelChange)="toggleSupportEquipment(equipment)"
                [inputId]="'support-' + equipment">
              </p-checkbox>
              <span class="text-sm text-grey-800">{{ equipment }}</span>
            </label>
          }
          </div>
        </div>
      }
    </div>

    <!-- Exercise Access -->
    <div class="border border-grey-100 rounded-xl overflow-hidden">
      <button
        type="button"
        [class]="hasExerciseAccessFilter() 
          ? 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-primary-50 hover:bg-primary-100 flex items-center justify-between cursor-pointer transition-colors'
          : 'w-full px-3 md:px-4 py-2.5 md:py-3 bg-grey-50 hover:bg-grey-100 flex items-center justify-between cursor-pointer transition-colors'"
        (click)="toggleSection('exerciseAccess')">
        <span [class]="hasExerciseAccessFilter() ? 'text-sm font-semibold text-primary-600' : 'text-sm font-semibold text-grey-700'">
          Exercise Access
        </span>
        <i [class]="(hasExerciseAccessFilter() ? 'pi pi-chevron-down text-primary-600' : 'pi pi-chevron-down text-grey-600') + ' chevron-icon' + (isSectionExpanded('exerciseAccess') ? ' rotated' : '')"></i>
      </button>
      
      @if (isSectionExpanded('exerciseAccess') && filterConstants) {
        <div class="expanded" [style.max-height]="responsiveService.isMobileView() ? 'none' : '300px'">
          <div [class]="responsiveService.isMobileView() ? 'p-3 md:p-4 space-y-2' : 'p-3 md:p-4 space-y-2 max-h-64 overflow-y-auto'">
          @for (access of getExerciseAccessOptions(); track access.key) {
            <label class="flex items-center gap-2 cursor-pointer hover:bg-grey-50 p-1 rounded">
              <p-checkbox
                [binary]="true"
                [ngModel]="selectedExerciseAccess() === access.key"
                (ngModelChange)="toggleExerciseAccess(access.key)"
                [inputId]="'access-' + access.key">
              </p-checkbox>
              <span class="text-sm text-grey-800">{{ access.label }}</span>
            </label>
          }
          </div>
        </div>
      }
    </div>

  </div>
</ng-template>
